export default {
  confirming_payment: "Confirmation du paiement",
  hang_tight: "Accrochez-vous",
};
